import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  display: inline-block;
  margin-left: 20px;
`;
